import { createContext, useContext, useState } from "react";
import { ContactDialog } from "@/components/ContactDialog";

const ContactContext = createContext({ openContact: () => {}, closeContact: () => {} });

export const useContact = () => useContext(ContactContext);

export const ContactProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openContact = () => setIsOpen(true);
  const closeContact = () => setIsOpen(false);

  return (
    <ContactContext.Provider value={{ openContact, closeContact }}>
      {children}
      <ContactDialog isOpen={isOpen} onClose={closeContact} />
    </ContactContext.Provider>
  );
};
